import React from 'react';
import Header from '../../components/layout/Header.jsx';
import Footer from '../../components/layout/Footer.jsx';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <>
            <div className='h-screen flex flex-col relative'>
                <Header title='Privacy Policy' staticHeader={true} sidebar={false} />
                <div className='max-w-3xl w-full mx-auto px-8 py-10 text-theme1-dark'>
                    <div className='mb-4'>
                        <strong>Last Updated:</strong> 31-01-2025
                    </div>
                    <div className='mb-4'>
                        Welcome to{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        (“LDR.ai ,” “we,” “us,” or “our”).{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        is a brand owned and operated by <strong>Kondiment World Wide SRL</strong> (“Kondiment”), a
                        company registered in Romania, with its principal place of business at Romania, Bucharest, Str.
                        General Gheorghe Manu, no. 7, District 1, registered with the Trade Registry (ORC), under no.
                        J40 / 2418 / 27.02.2014, having fiscal code (RO) 32853995. We respect your privacy and are
                        committed to protecting your personal data.
                    </div>
                    <div className='mb-8'>
                        This Privacy Policy explains how we collect, use, disclose, and safeguard your personal
                        information when you visit our website or use our services (collectively, the “Services”). By
                        accessing or using{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>
                        , you agree to the practices described in this Policy. If you do not agree with these terms,
                        please discontinue use of our Services immediately.
                    </div>
                    <div className='text-lg font-bold mb-2'>1. Scope of This Policy</div>
                    <div className='mb-4'>
                        This Privacy Policy applies to information collected through the{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        website, application, or any related online platforms and features that reference this Policy.
                        It does not apply to any information collected offline or through third-party websites or
                        services not controlled by{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        or Kondiment.
                    </div>

                    <div className='text-lg font-bold mb-2'>2. Who We Are</div>
                    <div className='mb-4'>
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        is a brand developed by Kondiment World Wide SRL. All data collected via{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        is controlled and processed by Kondiment. For any questions or requests regarding data
                        protection, please contact us at:
                    </div>
                    <ul className='list-disc list-inside mb-4'>
                        <li>Email: support@ldr.ai</li>
                        <li>
                            Postal Address: Bucharest, Str. General Gheorghe Manu, no. 7, District 1, registered with
                            the Trade Registry (ORC), under no. J40 / 2418 / 27.02.2014, having fiscal code (RO)
                            32853995.
                        </li>
                    </ul>

                    <div className='text-lg font-bold mb-2'>3. What Information We Collect</div>
                    <div className='mb-4'>
                        <strong>1. Personal Data:</strong>
                        <ul className='list-disc list-inside ml-6'>
                            <li>Identification Information (e.g., name, email address, phone number).</li>
                            <li>Account Credentials (if you create an account).</li>
                            <li>
                                Payment Details (if you purchase services, limited to what is necessary for billing).
                            </li>
                        </ul>
                    </div>
                    <div className='mb-4'>
                        <strong>2. Technical Data:</strong>
                        <ul className='list-disc list-inside ml-6'>
                            <li>Device and Browser Information (IP address, browser type, operating system).</li>
                            <li>Usage Data (pages viewed, date/time of visits, referral URLs).</li>
                        </ul>
                    </div>
                    <div className='mb-4'>
                        <strong>3. Cookies and Similar Technologies:</strong> <br></br>We use cookies, web beacons, and
                        similar tools to provide essential features, analyze traffic, and improve user experiences. For
                        more details, see <strong>Section 7</strong> below.
                    </div>

                    <div className='text-lg font-bold mb-2'>4. How We Use Your Information</div>
                    <div className='mb-4'>We may use the information we collect for purposes such as:</div>
                    <div className='mb-4'>
                        <strong>1. Providing and Personalizing Services:</strong>
                        <ul className='list-disc list-inside ml-6'>
                            <li>Creating and managing your account.</li>
                            <li>Customizing content and user experiences.</li>
                        </ul>
                    </div>
                    <div className='mb-4'>
                        <strong>1.1 Use of Google User Data:</strong>
                        <div className='mt-1 ml-6'>
                            <strong>1. Access and Scope:</strong>
                        </div>
                        <ul className='list-disc list-inside ml-10'>
                            <li>
                                <strong>Calendar and Google Meet Integration:</strong>{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>{' '}
                                requests permission to access and modify your Google Calendar for the sole purpose of
                                creating, scheduling, and updating virtual meetings (including automatic generation of
                                Google Meet links) directly from the{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>{' '}
                                interface.
                            </li>
                            <li>
                                <strong>Data Types Collected:</strong>{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>{' '}
                                only accesses basic calendar event data (such as event titles, times, attendees)
                                necessary to provide these scheduling features.
                            </li>
                        </ul>
                        <div className='mt-2 ml-6'>
                            <strong>2. Purpose and Limitations:</strong>
                        </div>
                        <ul className='list-disc list-inside ml-10'>
                            <li>
                                <strong>Primary Purpose:</strong> We use your Google user data to seamlessly integrate
                                your{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>{' '}
                                calendar with your Google Calendar, avoiding duplication and ensuring that any created
                                event or Google Meet link appears in both systems.
                            </li>
                            <li>
                                <strong>Limited Use Compliance:</strong>{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>
                                's use of Google user data conforms to Google's Limited Use requirements, which means we
                                do not use this data for any other purpose, such as advertising or other forms of data
                                mining.
                            </li>
                        </ul>
                        <div className='mt-2 ml-6'>
                            <strong>3. Data Storage and Sharing:</strong>
                        </div>
                        <ul className='list-disc list-inside ml-10'>
                            <li>
                                <strong>Storage:</strong> Any calendar metadata or meet link references are stored only
                                as necessary for providing in-app scheduling functions.
                            </li>
                            <li>
                                <strong>No Unauthorized Sharing:</strong> We do not share your Google user data
                                (including calendar events, participants, or scheduling information) with third parties
                                unless it is required by law or you explicitly grant permission.
                            </li>
                            <li>
                                <strong>User Control:</strong> You may revoke{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>
                                's access to your Google Calendar at any time through your Google Account permissions
                                page. Once revoked,{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>{' '}
                                will no longer have the ability to read or write to your calendar.
                            </li>
                        </ul>
                        <div className='mt-2 ml-6'>
                            <strong>4. Disclosure and In-Product Notifications:</strong>
                        </div>
                        <ul className='list-disc list-inside ml-10'>
                            <li>
                                <strong>Prominent Disclosure:</strong> We provide an in-product privacy notification
                                within{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>{' '}
                                that clearly explains how we use your Google user data for calendar synchronization and
                                generating Google Meet links.
                            </li>
                            <li>
                                <strong>Consent Screen:</strong> You will see a link to this Privacy Policy on the OAuth
                                consent screen, ensuring that the same policy is used and accessible.
                            </li>
                        </ul>
                        <div className='mt-2 ml-6'>
                            <strong>5. Ongoing Updates:</strong>
                        </div>
                        <ul className='list-disc list-inside ml-10'>
                            <li>
                                <strong>Accuracy and Revisions:</strong> Should{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>
                                's use of Google user data change, we will promptly update this Privacy Policy and our
                                in-product notifications, maintaining transparency and alignment with Google's policies.
                            </li>
                        </ul>
                        <div className='mt-2 ml-6'>
                            <strong>Note:</strong>
                        </div>
                        <div className='ml-10'>
                            By using the{' '}
                            <Link to='/' className='text-theme1-info'>
                                LDR.ai
                            </Link>{' '}
                            Google Calendar integration, you agree to this section of our Privacy Policy, which
                            describes our handling of Google user data.
                        </div>
                    </div>
                    <div className='mb-4'>
                        <strong>2. Communicating with You:</strong>
                        <ul className='list-disc list-inside ml-6'>
                            <li>
                                Sending service updates, newsletters, or promotional materials (with your consent, where
                                required).
                            </li>
                            <li>Responding to customer support inquiries.</li>
                        </ul>
                    </div>
                    <div className='mb-4'>
                        <strong>3. Analytics and Improvements:</strong>
                        <ul className='list-disc list-inside ml-6'>
                            <li>Monitoring usage trends to enhance our Services.</li>
                            <li>Conducting data analysis to optimize platform performance.</li>
                        </ul>
                    </div>
                    <div className='mb-4'>
                        <strong>4. Legal and Security:</strong>
                        <ul className='list-disc list-inside ml-6'>
                            <li>Detecting and preventing fraud or misuse of our Services.</li>
                            <li>Complying with legal obligations and enforcing our terms.</li>
                        </ul>
                    </div>

                    <div className='text-lg font-bold mb-2'>5. Legal Bases for Processing</div>
                    <div className='mb-4'>
                        Depending on your location and the applicable data protection laws, we rely on different legal
                        grounds for processing your personal data, including:
                    </div>
                    <ul className='list-disc list-inside mb-4 ml-6'>
                        <li>
                            <strong>Performance of a Contract:</strong> When providing the Services you have requested.
                        </li>
                        <li>
                            <strong>Legitimate Interests:</strong> For security measures, product improvements, and
                            certain marketing activities, where such interests are not overridden by your rights.
                        </li>
                        <li>
                            <strong>Consent:</strong> For certain direct marketing communications or when otherwise
                            required by law.
                        </li>
                        <li>
                            <strong>Legal Obligations:</strong> To comply with applicable legal or regulatory
                            requirements.
                        </li>
                    </ul>

                    <div className='text-lg font-bold mb-2'>6. Sharing and Disclosure of Information</div>
                    <div className='mb-4'>We may share your information in the following circumstances:</div>
                    <div className='mb-4'>
                        <strong>1. Service Providers:</strong> We engage trusted third parties for hosting, analytics,
                        payment processing, and other operational services under confidentiality obligations.
                    </div>
                    <div className='mb-4'>
                        <strong>2. Corporate Transactions:</strong> If Kondiment or{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        undergoes a merger, acquisition, or sale of assets, user data may be transferred to the new
                        entity.
                    </div>
                    <div className='mb-4'>
                        <strong>3. Legal Requirements:</strong> We may disclose data if required to do so by law or in
                        response to valid requests by public authorities (e.g., law enforcement).
                    </div>
                    <div className='mb-4'>
                        <strong>4. With Your Consent:</strong> We may share information with third parties when you
                        explicitly agree.
                    </div>

                    <div className='text-lg font-bold mb-2'>7. Cookies and Similar Technologies</div>
                    <div className='mb-4'>
                        <strong>1. Purpose of Cookies:</strong>
                        <ul className='list-disc list-inside ml-6'>
                            <li>
                                Cookies help us remember your preferences, personalize content, and analyze how users
                                navigate our site.
                            </li>
                            <li>
                                Some are session cookies that expire when you close your browser, while others are
                                persistent cookies stored for longer periods.
                            </li>
                        </ul>
                    </div>
                    <div className='mb-4'>
                        <strong>2. Managing Cookies:</strong>
                        <ul className='list-disc list-inside ml-6'>
                            <li>
                                You can control or disable cookies in your browser settings. However, some features of{' '}
                                <Link to='/' className='text-theme1-info'>
                                    LDR.ai
                                </Link>{' '}
                                might not function properly if you block cookies.
                            </li>
                            <li>
                                For additional details on how we use cookies and your choices, please refer to our
                                Cookie Policy.
                            </li>
                        </ul>
                    </div>

                    <div className='text-lg font-bold mb-2'>8. Data Retention</div>
                    <div className='mb-4'>
                        We retain personal data for as long as necessary to fulfill the purposes outlined in this
                        Policy, unless a longer retention period is required or permitted by law. Once we no longer need
                        your information, we will securely dispose of or anonymize it.
                    </div>

                    <div className='text-lg font-bold mb-2'>9. Your Rights</div>
                    <div className='mb-4'>Depending on local laws, you may have the right to:</div>
                    <ul className='list-disc list-inside mb-4 ml-6'>
                        <li>
                            <strong>Access:</strong> Request a copy of the personal data we hold about you.
                        </li>
                        <li>
                            <strong>Rectification:</strong> Update or correct inaccurate or incomplete information.
                        </li>
                        <li>
                            <strong>Erasure:</strong> Ask us to delete your personal data under certain circumstances.
                        </li>
                        <li>
                            <strong>Restriction or Objection:</strong> Limit or object to the processing of your data.
                        </li>
                        <li>
                            <strong>Data Portability:</strong> Receive your personal data in a structured format.
                        </li>
                        <li>
                            <strong>Withdraw Consent:</strong> If processing is based on consent, you can withdraw it at
                            any time.
                        </li>
                    </ul>
                    <div className='mb-4'>
                        To exercise these rights, please contact us using the details in <strong>Section 2</strong>. We
                        will respond to your request within a reasonable timeframe, in accordance with applicable laws.
                    </div>

                    <div className='text-lg font-bold mb-2'>10. International Transfers</div>
                    <div className='mb-4'>
                        If you access{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        from outside our operational jurisdiction, be aware that your data may be transferred to,
                        stored, or processed in a country different from your own. We take steps to ensure that such
                        transfers comply with data protection laws, including the use of standard contractual clauses or
                        equivalent safeguards.
                    </div>

                    <div className='text-lg font-bold mb-2'>11. Security Measures</div>
                    <div className='mb-4'>
                        We strive to protect your personal data by implementing reasonable technical and organizational
                        safeguards. However, no transmission or storage system is 100% secure, and we cannot guarantee
                        absolute security of your information.
                    </div>

                    <div className='text-lg font-bold mb-2'>12. Children's Privacy</div>
                    <div className='mb-4'>
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        is not directed at children, and we do not knowingly collect personal data from individuals
                        under the age required by local laws. If you believe we have collected such data, please contact
                        us immediately to request deletion.
                    </div>

                    <div className='text-lg font-bold mb-2'>13. Changes to This Privacy Policy</div>
                    <div className='mb-4'>
                        We may modify this Privacy Policy from time to time to reflect changes in our practices or legal
                        requirements. Any updates will be posted on this page, and the “Last Updated” date will be
                        revised accordingly. Your continued use of our Services after these changes indicates your
                        acceptance of the updated Policy.
                    </div>
                    <div className='text-lg font-bold mb-2'>14. Contact Us</div>
                    <div className='mb-10'>
                        If you have any questions, comments, or requests regarding this Privacy Policy or our data
                        handling practices, please contact{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        (Kondiment World Wide SRL) at:
                        <ul className='list-disc list-inside ml-6'>
                            <li>
                                <strong>Email:</strong> support@ldr.ai
                            </li>
                            <li>
                                <strong>Address:</strong> Bucharest, Str. General Gheorghe Manu, no. 7, District 1,
                                registered with the Trade Registry (ORC), under no. J40 / 2418 / 27.02.2014, having
                                fiscal code (RO) 32853995.
                            </li>
                        </ul>
                    </div>
                    <div>
                        <strong>© 2025 Kondiment World Wide SRL. All Rights Reserved.</strong> <br></br>
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        is a brand of Kondiment World Wide SRL. Use of our Services implies acceptance of this Privacy
                        Policy. If you do not agree with any part of it, please discontinue use immediately.
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default PrivacyPolicy;
